var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    [
      _c("li", [
        _c("h3", [_vm._v(_vm._s(_vm.t("health", "Column selection", {})))])
      ]),
      _vm._v(" "),
      _c(
        "ActionCheckbox",
        {
          attrs: { checked: _vm.person.feelingColumnMood },
          on: {
            change: function($event) {
              return _vm.$store.dispatch("setValue", {
                key: "feelingColumnMood",
                value: $event.target.checked
              })
            }
          }
        },
        [_vm._v("\n\t\t" + _vm._s(_vm.t("health", "Mood", {})) + "\n\t")]
      ),
      _vm._v(" "),
      _c(
        "ActionCheckbox",
        {
          attrs: { checked: _vm.person.feelingColumnSadnessLevel },
          on: {
            change: function($event) {
              return _vm.$store.dispatch("setValue", {
                key: "feelingColumnSadnessLevel",
                value: $event.target.checked
              })
            }
          }
        },
        [
          _vm._v(
            "\n\t\t" + _vm._s(_vm.t("health", "Sadness level", {})) + "\n\t"
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "ActionCheckbox",
        {
          attrs: { checked: _vm.person.feelingColumnSymptoms },
          on: {
            change: function($event) {
              return _vm.$store.dispatch("setValue", {
                key: "feelingColumnSymptoms",
                value: $event.target.checked
              })
            }
          }
        },
        [_vm._v("\n\t\t" + _vm._s(_vm.t("health", "Symptoms")) + "\n\t")]
      ),
      _vm._v(" "),
      _c(
        "ActionCheckbox",
        {
          attrs: { checked: _vm.person.feelingColumnAttacks },
          on: {
            change: function($event) {
              return _vm.$store.dispatch("setValue", {
                key: "feelingColumnAttacks",
                value: $event.target.checked
              })
            }
          }
        },
        [_vm._v("\n\t\t" + _vm._s(_vm.t("health", "Attacks")) + "\n\t")]
      ),
      _vm._v(" "),
      _c(
        "ActionCheckbox",
        {
          attrs: { checked: _vm.person.feelingColumnMedication },
          on: {
            change: function($event) {
              return _vm.$store.dispatch("setValue", {
                key: "feelingColumnMedication",
                value: $event.target.checked
              })
            }
          }
        },
        [_vm._v("\n\t\t" + _vm._s(_vm.t("health", "Medication")) + "\n\t")]
      ),
      _vm._v(" "),
      _c(
        "ActionCheckbox",
        {
          attrs: { checked: _vm.person.feelingColumnPain },
          on: {
            change: function($event) {
              return _vm.$store.dispatch("setValue", {
                key: "feelingColumnPain",
                value: $event.target.checked
              })
            }
          }
        },
        [_vm._v("\n\t\t" + _vm._s(_vm.t("health", "Pain")) + "\n\t")]
      ),
      _vm._v(" "),
      _c(
        "ActionCheckbox",
        {
          attrs: { checked: _vm.person.feelingColumnEnergy },
          on: {
            change: function($event) {
              return _vm.$store.dispatch("setValue", {
                key: "feelingColumnEnergy",
                value: $event.target.checked
              })
            }
          }
        },
        [_vm._v("\n\t\t" + _vm._s(_vm.t("health", "Energy")) + "\n\t")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }